import * as React from 'react'

import { QuestionS as HelpIcon } from '../../icons'
import { getElementPosition } from '../../utils/generic'
import { Text } from '../texts'
import { Tooltip } from '../tooltip'
import Waves from '../waves'
import { Styled } from './styled'

export const MenuItem = (props) => {
    const {
    Icon,
    iconColor,
    text,
    textColor = 'gray',
    subText,
    subTextColor,
    fontSize,
    withBorder,
    size = 'l',
    onClick,
    img,
    helpToolTip,
    disabled,
    tooltipPosition,
    withoutWaves,
  } = props;
  const [tooltip, setTooltip] = React.useState(null)
  return (<Styled.Item
    // eslint-disable-next-line react/jsx-no-bind
    onClick={e => {
      e.stopPropagation()
      onClick(e)
    }}
    helpToolTip={helpToolTip}
    withBorder={withBorder}
    size={size}
    disabled={disabled}
  >
    <Styled.IconWithText iconColor={iconColor}>
      {img ? <img src={img} alt="" /> : Icon && <Icon />}
      <Text
        color={disabled ? 'disabled' : textColor}
        fontSize={fontSize}
      >
        {text}
      </Text>
    </Styled.IconWithText>
    <Styled.SubText>
      <Text
        fontFamily='Thin'
        color={subTextColor}
        fontSize={fontSize}
      >
        {subText}
      </Text>
    </Styled.SubText>
    {helpToolTip && (
      <Styled.TooltipContainer
        // eslint-disable-next-line react/jsx-no-bind
        onMouseEnter={el =>
          setTooltip({
            targetElement: getElementPosition(el),
            position: tooltipPosition || 'right',
            text: helpToolTip,
            speed: 's',
            description: '',
          })
        }
        // eslint-disable-next-line react/jsx-no-bind
        onMouseLeave={() => setTooltip(null)}
      >
        <HelpIcon/>
      </Styled.TooltipContainer>
    )}
    {!withoutWaves ? <Waves /> : null}
    {tooltip && <Tooltip
      position={tooltip.position}
      targetTop={tooltip.targetElement.top}
      targetBottom={tooltip.targetElement.bottom}
      targetLeft={tooltip.targetElement.left}
      targetRight={tooltip.targetElement.right}
      targetWidth={tooltip.targetElement.width}
      targetHeight={tooltip.targetElement.height}
      text={tooltip.text}
      speed={tooltip.speed}
      description={tooltip.description}
    />
    }
  </Styled.Item>)
};
